import InvestChart from './invest-chart';

export default InvestChart;
